module.exports = __webpack_public_path__ + "img/iphone_6_plus_white_port.d6c50fbd.png";